




























import {Component, Prop, Vue} from 'vue-property-decorator';
import OrderItemCard from "./OrderItemCard.vue";
import IconCustom from "@/components/lib/IconCustom.vue";
import {IRequestTravel, IRequestTravelHistory} from "@/entities";
import {StatusTagType} from "@/components/lib/models";

@Component({
  components: {
    OrderItemCard,
    IconCustom
  }
})
export default class OrderPlanItemCard extends Vue {

  @Prop() readonly data!: IRequestTravel
  @Prop({ default: false }) readonly showControl?: boolean
  @Prop() readonly token?: string

  private mapStatus(status?: string): StatusTagType {
    switch (status) {
      case "done":
        return 'success'
      case "development":
        return 'progress'
      case "new":
        return 'none'
      default:
        return 'warning'
    }
  }

  get showLinkControl(): boolean {
    return !!this.data.travel;
  }

  get name(): string {
    const travel = this.data.travel;
    const name = travel ? (this.$t('plan-travel') + ' "' + travel.name + '"') : this.$t('custom-plan');
    return this.$options.filters?.capitalize(name);
  }

  get mappedStatus(): StatusTagType {
    return this.mapStatus(this.data.status);
  }

  private fetchHistories(): Promise<IRequestTravelHistory[]> {
    return this.$storage.actions.getRequestTravelHistories({
      key: this.data.id
    });
  }

}
